import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Loadable } from '../../../../common';
import { addValidationSchema, editValidationSchema } from '../../../../store/validations/client';
import BucketFieldArray from './BucketFieldArray';
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import InventoryIcon from "@mui/icons-material/Inventory";
import StorageIcon from "@mui/icons-material/Storage";

import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Step,
    StepButton,
    Stepper,
    Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { AssignProducts } from "./CreateClientStepper/AssignProducts";
import { CreateClient } from "./CreateClientStepper/CreateClient";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { infoToastify } from "../../../../util/toast";

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: 8,
        width: '90%',
    },
    autoComplete: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: 8,
        width: '90%',
    },
    portlet: {
        'box-shadow': 'none',
        margin: 8
    },
    error: {
        width: 800
    },
    formControl: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        width: '80%'
    },
}));

const useValidationAlertStyles = makeStyles(theme => ({
    validationAlert: {
        padding: "0 16px 0 16px"
    }
}));


export default function ClientEditPage({
    initialValues, isActive, intl, history, clientId,
    bucket, bucketValidity, ftpUserValidity, isSuperAdmin, clientGetPending,clients,
    clientsCreatePending, clientsUpdatePending, mode, parserList, clientsActivatePending, clientsDeactivatePending, client,clientsCreateError,
    actions: { resetBuckets, clientGet, createClientV3, updateClientV3, addClientProducts, clientCreate, addClientBuckets, clientUpdate, getParsers, bucketAvailability, ftpUserAvailability,
        deactivateClient, activateClient, getClientsTiny } }
) {
    const { tabId }:any = useParams();
    const [isClientActive, setClientActive] = useState(true);
    const [isConfirmOpen, setConfirmOpen] = useState(false);
    let arrayPush = null;
    const [activeStep, setActiveStep] = React.useState(tabId ?+tabId : 0);
    const [clientNew, setClient] = React.useState(null);
    const [clientIdNew, setClientId] = React.useState(clientId ?? 0); 
    const classes = useStyles();
    const isEdit = mode === 'edit';
    const [completedSteps, setCompletedSteps] = React.useState([]);
    const handleCallback = () => {
        getClientsTiny()
        history.push('/admin/clients?persist=true');
    }
    useEffect(() => {
        if (mode === 'edit') {
            clientGet(clientId);
        }
    }, []);

    const handleCallbacakCreateClient = (res)=> {
        setClientId(res??0);
        setNextStep();
    }

       const handleCallbacakUpdateClient = ()=> {
        setNextStep();
    }

    const setNextStep = ()=> {
        setCompletedSteps((prev) =>
            prev.includes(activeStep) ? prev : [...prev, activeStep]
        );
        setActiveStep((prev) => prev + 1);
    }

    const handleNext = async (data: any) => {

        const payload = {
            name: data.name,
            clientId: isEdit ? clientId ? +clientId : data.clientId : 0,
            displayName: data.displayName?.trim(),
            licenseNumber: data.licenseNumber,
            schema: data.schema?.trim(),
            goLive: data.goLive,
            address: data.address?.trim(),
            city: data.city?.trim(),
            zip: data.zip,
            streetAddress: data.streetAddress?.trim(),
            contact:
                data.contact.replace(/\D/g, '').length === 0
                    ? ''
                    : data.contact,
            maxUsers: data.maxUsers,
            fiscalYear: getFiscalYear(data.fiscalDay, data.fiscalMonth),
            timeZone: data.timeZone.id,
            state: data.state.abbreviation,
        };

        try {
            if(!isEdit)
                createClientV3(payload, handleCallbacakCreateClient);
            else
                updateClientV3(payload,handleCallbacakUpdateClient)
        } catch (error) {
            toast.error("Failed to Register client", error.message)
        }
    };

     const handleProductAPICallBack = () => {
        setNextStep();
    }

    const redirectToListing = () => {
        history.push(`/admin/clients`);
    }

    const handleSaveBuckets = (data: any, errors: any) => {
        if(data.buckets){
            for (let index = 0; index < data.buckets.length; index++) {
                const element = data.buckets[index];
                if(!element.name.includes("sliced-")){
                    element.name = "sliced-"+element.name
                }
                if(!element.ftpUser.name.includes("admin-")){
                    element.ftpUser.name = "admin-"+element.ftpUser.name
                }
            }
        }
        const payload = {
            name: data.name,
            clientId: data.clientId ?? clientIdNew,
            buckets: data.buckets,
        };
        const hasErrors = Object.keys(errors).length > 0;

        if (payload.buckets && payload.buckets.length > 0 && !hasErrors) {
            infoToastify(<><b>Creating Client</b><br/>Client Creation is in Progress, You'll be notified when it's complete.</>);
        
            addClientBuckets(payload, redirectToListing);
        }
    };

    const handleNextForProducts = async (data: any) => {
        const payload = {
            clientId: data.clientId ?? +clientIdNew,
            hasDashboardAccess: data.hasDashboardAccess,
            hasCMSAccess: data.hasCMSAccess,
            hasCMSRCMStatusReportAccess: data.hasCMSRCMStatusReportAccess,
            hasEstimatorAccess: data.hasEstimatorAccess,
            hasPricerAccess: data.hasPricerAccess,
            hasVendorManagementAccess: data.hasVendorManagementAccess,
            updatedBy: data.displayName,
            updatedOn: new Date()
        }
        
        addClientProducts(payload,handleProductAPICallBack);        
    }


    //Setting Toggle with client status
    useEffect(() => {
        if (mode === 'edit') {
            setClientActive(isActive)
        }
    }, [isActive])

    useEffect(() => {
        getParsers();

        return function cleanup() {
            resetBuckets();
        }
    }, [getParsers, resetBuckets]);

    const onClickAddBucket = () => {
        if (arrayPush) {
            if (isEdit && client?.clientId) {
                arrayPush({
                    ...bucket,
                    clientId: client?.clientId,
                    id: 0,
                    ftpUser: {
                        ...bucket.ftpUser,
                        id: 0,

                    }

                });
                return
            }
            arrayPush({
                ...bucket
            });
        }
    };

    const bindArrayPush = (push) => {
        arrayPush = push;
    };

    const getFiscalYear = (day, month) => {
        return month + '/' + day;
    }

    const handleStatusToggle = (isChecked) => {
        setClientActive(isChecked);
        handleConfirmOpen();
    }

    const handleConfirmOpen = () => {
        setConfirmOpen(true);
    }
    const handleConfirmClose = () => {
        setConfirmOpen(false);
        //resetting if user cancel the operation
        setClientActive(isActive);
    }

    const handleClientStatusChange = () => {
        setConfirmOpen(false);
        if (isClientActive) {
            activateClient(clientId, handleStatusCallback)
        } else {
            deactivateClient(clientId, handleStatusCallback);
        }
    }

    const handleStatusCallback = () => {
        handleCallback();
        getClientsTiny();
    }

    const isBucketOrUsernameInvalid = () => {
        return JSON.stringify(bucketValidity).includes('true') || JSON.stringify(ftpUserValidity).includes('true')

    }
    const WIZARD_STEPS = [
      {
        key: "createClient",
        label: isEdit && !tabId ? "Edit Client" : "Create Client",
        icon: <PersonAddIcon />,
        description: "Basic client information",
        optional: false,
      },
      {
        key: "assignProducts",
        label: "Assign Products",
        icon: <InventoryIcon />,
        description: "Select products for client",
        optional: false,
      },
      {
        key: "createBuckets",
        label: isEdit && !tabId ?"Edit Buckets":"Create Buckets",
        icon: <StorageIcon />,
        description: "Background bucket creation",
        optional: true,
      },
    ];
    

    return (
        (<Loadable loading={clientsCreatePending || clientsUpdatePending || clientsActivatePending || clientsDeactivatePending || clientGetPending}>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={mode === 'create' ? addValidationSchema : editValidationSchema}
                validate={values => {
                    const errors: { [key: string]: string } = {};
                    const zipRegex = /^\d{5}(-\d{4})?$/;
                    for (let i = 0; i < clients?.length; i++) {

                        const currentAddedClientDisplayName =
                            values.displayName?.toLowerCase()?.trim();

                        const currentAddedschema =
                            values.schema?.toLowerCase()?.trim();
                        
                        const displayNameInList =
                            clients[i]?.name?.toLowerCase();
                        
                            const schemaNameInList =
                            clients[i]?.schema?.toLowerCase();
                        
                        if (clients[i]?.clientId!==values?.clientId && currentAddedClientDisplayName === displayNameInList) {
                            errors.displayName =
                                "Client with this Display Name already exists";
                        }

                        if (clients[i]?.clientId!==values?.clientId && currentAddedschema === schemaNameInList) {
                            errors.schema =
                                "Schema Name already in use";
                        }
                    }
                    
                    if (values.state === null) {
                        errors.state = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }
                    if (values.timeZone === null) {
                        errors.timeZone = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                    if (!values.licenseNumber) {
                        errors.licenseNumber = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                    if (!values.address) {
                        errors.address = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                    if (!values.city) {
                        errors.city = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }
                    if (!values.zip) {
                        errors.zip = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                     if (!zipRegex.test(values.zip)) {
                        errors.zip = 'Invalid ZIP code format';
                     }

                    if (values.contact.replace(/\D/g, '').length === 0) {
                        errors.contact = intl.formatMessage({
                            id: "AUTH.VALIDATION.REQUIRED_FIELD"
                        });
                    }

                    if (values.contact.replace(/\D/g, '').length !== 0 && !(/^[1-9]\d{9}$/.test(values.contact.replace(/\D/g, '')))) {
                        errors.contact = 'Invalid Phone number';
                    }

                    if (values.licenseNumber.length > 10) {
                        errors.licenseNumber = "License Number should not exceed 10 characters.";

                    }

                    return errors;
                }}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    let payload = {
                        name: values.name,
                        displayName: values.displayName?.trim(),
                        licenseNumber: values.licenseNumber,
                        schema: values.schema?.trim(),
                        goLive: values.goLive,
                        address: values.address?.trim(),
                        city: values.city?.trim(),
                        zip: values.zip,
                        streetAddress: values.streetAddress?.trim(),
                        contact: values.contact.replace(/\D/g, '').length === 0 ? '' : values.contact,
                        maxUsers: values.maxUsers,
                        fiscalYear: getFiscalYear(values.fiscalDay, values.fiscalMonth),
                        timeZone: values.timeZone.id,
                        state: values.state.abbreviation,
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    setFieldTouched,
                    dirty
                }) => {
                    const customhandleBlur = (e) => {
                        if (e.target.value !== '') {
                            bucketAvailability(e.target.value, e.target.name);
                        }
                        setFieldTouched(e.target.name, true, false);
                    }
                    const customftpUserhandleBlur = (e) => {
                        if (e.target.value !== '') {
                            ftpUserAvailability(e.target.value, e.target.name);
                        }
                        setFieldTouched(e.target.name, true, false);
                    }

                    const { buckets: _bucketsValues, ...filteredValues } = values;
                    const { buckets: _bucketsErrors, ...filteredErrors } = errors;
                    const clientData = {
                        touched:touched,
                        errors:filteredErrors,
                        values:filteredValues,
                    }
                    return (
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            padding={2}
                            
                        >

                            <Box
                                sx={{
                                    width: "100%",
                                    mb: 3,
                                    p: 2,
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                <Stepper activeStep={activeStep} alternativeLabel>
                                    {WIZARD_STEPS.map((step, index) => {
                                        const Icon = step.icon;

                                        const isClickable =
                                            (index === activeStep ||
                                            completedSteps.includes(index)) && isEdit;

                                        return (
                                            <Step key={step.key} completed={completedSteps.includes(index)}>
                                                <StepButton
                                                    onClick={() => {
                                                        if (isClickable) {
                                                            setActiveStep(index);
                                                        }
                                                    }}
                                                    disabled={!isClickable}
                                                    icon={step.icon
                                                    }
                                                    >
                                                        <Typography
                                                            sx={{
                                                            fontSize: 16,
                                                            fontWeight:
                                                                index === activeStep ? 600 : 400,
                                                            color: completedSteps.includes(index)
                                                                ? "green"
                                                                : "primary.main"
                                                            }}
                                                        >
                                                            {step.label}
                                                        </Typography>
                                                </StepButton>
                                            </Step>
                                        );
                                    })}
                                </Stepper>
                            </Box>


                            <Box sx={{
                                mb: 3,
                                p: 2,
                                backgroundColor: "#fff",
                                borderRadius: 2,
                                borderBottom: "1px solid #ddd",
                            }}>
                                {activeStep === 0 && (
                                    <CreateClient
                                        setClient={setClient}
                                        onNext={handleNext}
                                        onSkip={() =>{ 
                                                        setActiveStep(1);
                                                        setCompletedSteps((prev) =>
                                                prev.includes(activeStep) ? prev : [...prev, activeStep]
                                            );
                                                        }}
                                        data = {clientData}
                                        isEdit = {isEdit}
                                        statusChanged={handleStatusToggle}
                                        isClientActive = {isActive}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                    />
                                )}

                                {activeStep === 1 && (
                                    <AssignProducts
                                        onNext={handleNextForProducts}
                                        isEdit={isEdit}
                                        onSkip={() => {
                                            setActiveStep(2);
                                            setCompletedSteps((prev) =>
                                                prev.includes(activeStep) ? prev : [...prev, activeStep]
                                            );
                                        }}
                                        data={values}
                                        onChange={handleChange}
                                        handleBlur={handleBlur}
                                    />
                                )}

                                {activeStep === 2 && (
                                    <Box
                                        mt={1.5}
                                        border={1}
                                        borderColor="divider"
                                        borderRadius={2}
                                        sx={{
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        <ValidationAlert errors={errors} touched={touched} isEdit={isEdit} />
                                        {/* Header */}
                                        <Box
                                            px={2}
                                            py={1.5}
                                            borderBottom={1}
                                            borderColor="divider"
                                            bgcolor="#e7ebee88"
                                        >
                                            <Grid container alignItems="center">
                                                <Grid item xs={10}>
                                                    <Typography variant="h6" mb={0}>
                                                        Buckets
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={2} textAlign="right">
                                                    <Button
                                                        type="button"
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={onClickAddBucket}
                                                    >
                                                        Add
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Box>

                                        {/* Body */}
                                        <Box
                                            px={2} py={2}>
                                            <BucketFieldArray
                                                clientsCreateError={clientsCreateError}
                                                setFieldValue={setFieldValue}
                                                values={values}
                                                bindArrayPush={bindArrayPush}
                                                mode={mode}
                                                parserList={parserList}
                                                handleBlur={handleBlur}
                                                customhandleBlur={customhandleBlur}
                                                customftpUserhandleBlur={customftpUserhandleBlur}
                                                handleChange={handleChange}
                                                touched={touched}
                                                errors={errors}
                                                bucketValidity={bucketValidity}
                                                ftpUserValidity={ftpUserValidity}
                                                clientsBuckets={client?.buckets}
                                            />

                                            <Box display="flex" justifyContent="center" mt={1.5}  columnGap={5}>
                                                <Button variant="contained" onClick={() => handleSaveBuckets(values,errors)}>
                                                    Save
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>

                                )}
                            </Box>
                            
                        </Box>
                    );
                }}
            </Formik>
            <Dialog open={isConfirmOpen} onClose={handleConfirmClose}>
                <DialogTitle>
                    {isClientActive ? 'Activate' : 'Deactivate'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to  {isClientActive ? 'activate' : 'deactivate'} this client ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button type='button' onClick={handleConfirmClose}>
                        Cancel
                    </Button>
                    <Button
                        type='button'
                        onClick={handleClientStatusChange}
                        color="primary">
                        {isClientActive ? 'Activate' : 'Deactivate'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Loadable>)
    );
}
const ValidationAlert = ({ errors, touched, isEdit }) => {
  const classes = useValidationAlertStyles();
  const hasErrors = Object.keys(errors).length > 0;
  const isCreateAndUntouched =
    !isEdit &&
    Object.keys(errors).length === 0 &&
    Object.keys(touched).length === 0;
  return hasErrors || isCreateAndUntouched ? (
    <Alert severity="error" classes={{ root: classes.validationAlert }}>
      Please fill out required fields and fix validation errors
    </Alert>
  ) : null;
}